<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="sidebar-section-container" [ngClass]="{ collapsed: isCollapsed }">
  <div class="top-container">
    <button
      mat-icon-button
      [attr.aria-label]="'translations.global.ariaLabels.toggleSidebar' | transloco"
      class="close-menu-btn"
      (click)="toggleSidebar()"
      *ngIf="sections"
    >
      <svg class="svg" aria-hidden="true">
        <use ogSvgUnify="assets/sprite/sprite.svg#double-arrow-left"></use>
      </svg>
    </button>
  </div>

  <div class="sidebar-content">
    <div class="side-nav-edit-top">
      <div class="title small bold">
        {{ title }}
      </div>
      <ng-content select="[sidebar-top]"></ng-content>
    </div>

    <div class="sidebar-navigation-items-container" *ngIf="sections">
      <div class="medium bold manage-title">
        {{ 'translations.manage' | transloco }}
      </div>

      <div class="sidebar-section {{ section.class }}" *ngFor="let section of sections">
        <div class="sidebar-item-separator" *ngIf="section.displayTopLineSeparator"></div>

        <ng-container *ngFor="let link of section.staticLinks">
          <a
            class="sidebar-static-item"
            tabindex="0"
            role="button"
            (click)="onLinkClick(link.uri)"
            [routerLink]="link.uri && !link.preventRedirection ? link.uri : null"
            [routerLinkActiveOptions]="link.uri.startsWith('members') ? { exact: false } : { exact: true }"
            [routerLinkActive]="'is_active'"
          >
            <div class="sidebar-static-link small">
              <ng-container *ngIf="loaderActive && link.hasLoader">
                <mat-spinner class="loader" [diameter]="20"></mat-spinner>
              </ng-container>
              <i *ngIf="!link.icon" class="icon no-icon"></i>
              <svg
                class="icon-svg icon svg"
                role="img"
                [attr.aria-label]="'translations.global.ariaLabels.icons.menuIconName' | transloco"
                *ngIf="link.icon && link.icon.svg"
                [ngClass]="link.icon.color ? 'item__icon--' + link.icon.color : 'no-icon'"
                [innerHTML]="link.icon.svg | safeHtml"
              ></svg>
              <i
                class="material-icons icon"
                aria-hidden="true"
                *ngIf="link.icon && link.icon.name"
                [ngClass]="link.icon.color ? 'item__icon--' + link.icon.color : 'no-icon'"
              >
                {{ link.icon.name }}
              </i>
              <i
                class="{{ link.icon.class }} icon"
                aria-hidden="true"
                *ngIf="link.icon && link.icon.class"
                [ngClass]="link.icon.color ? 'item__icon--' + link.icon.color : 'no-icon'"
              >
                <span *ngFor="let extraClass of link.icon.extraClasses" [ngClass]="extraClass"></span>
              </i>
              <span>{{ link.title }}</span>
            </div>
          </a>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="sections && sections?.length">
      <ng-content select="[sidebar-footer]"></ng-content>
    </ng-container>
  </div>
</div>
